module.exports = __webpack_public_path__ + "static/media/kalam-light-webfont.5408887f.woff2";